import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared';
import {PriceBookHeaderContainerModel} from '../../../../../../models/aggregates/erp/price-book';
import {Core2Config} from '../../shared';


@Injectable({
  providedIn: 'root'
})
export class PriceBookHdrService extends BaseApiTemplateService<PriceBookHeaderContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.DOMAIN_URL_PREFIX + 'fi-price-book-hdr';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.DOMAIN_URL_PREFIX + 'fi-price-book-hdr';
    this.endpoint_path = Core2Config.DOMAIN_URL_PREFIX + 'fi-price-book-hdr';
    this.httpClient = http;
  }

}


